import { Alert, Card, CardContent, CardHeader, LinearProgress, Link, Stack } from '@mui/material';
import React from 'react';
import { useInboxClient, useInboxTranslation } from '../Hooks';
import { GetNotificationsRequest } from '../Models';

export interface InboxCardProps {
    onUnreadClick: () => void;
    onRequireResponseClick: () => void;
    headerAction?: React.ReactNode;
}

export const InboxCard: React.FC<InboxCardProps> = (props) => {
    const { t } = useInboxTranslation();
    const inboxClient = useInboxClient();

    const [countUnread, setCountUnread] = React.useState<number>();
    const [countRequireResponse, setCountRequireResponse] = React.useState<number>();
    const [error, setError] = React.useState();

    React.useEffect(() => {
        const requestUnread: GetNotificationsRequest = { read: false, page: 1, size: 1 };
        const requestRequireResponse: GetNotificationsRequest = { waitingForResponse: true, page: 1, size: 1 };
        Promise.all([inboxClient.getList(requestUnread), inboxClient.getList(requestRequireResponse)])
            .then(([unreadResponse, waitingResponse]) => {
                setCountUnread(unreadResponse.totalCount);
                setCountRequireResponse(waitingResponse.totalCount);
            })
            .catch(setError);
    }, [inboxClient]);

    const InboxCardContent = () => {
        if (error) {
            return <Alert severity='error'>{t('errorMessage')}</Alert>;
        }
        if (countUnread === undefined || countRequireResponse === undefined) {
            return <LinearProgress />;
        }
        return (
            <Stack spacing={2} alignItems='flex-start'>
                <Link
                    style={{ cursor: 'pointer' }}
                    onClick={() => props.onUnreadClick()}
                    component='button'
                    variant='body1'
                    data-test='unread-notifications-count-link'
                >
                    {t('inboxCard.unreadNotifications', { count: countUnread })}
                </Link>
                <Link
                    style={{ cursor: 'pointer' }}
                    onClick={() => props.onRequireResponseClick()}
                    component='button'
                    variant='body1'
                    data-test='require-response-count-link'
                >
                    {t('inboxCard.requireResponse', { count: countRequireResponse })}
                </Link>
            </Stack>
        );
    };

    return (
        <Card data-test='inbox-card' sx={{ width: '100%', height: '100%' }}>
            <CardHeader
                sx={{ display: 'inline-flex' }}
                title={t('inboxCard.titleNotifications')}
                data-test='inbox-card-title'
                action={props.headerAction}
            />
            <CardContent data-test='inbox-card-content'>
                <InboxCardContent />
            </CardContent>
        </Card>
    );
};
